module.exports = __webpack_public_path__ + "img/4.63ac2855.jpg";